var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabs-wrap"},_vm._l((_vm.list),function(t,i){return _c('div',{key:i,staticClass:"tabs-item",class:i === _vm.index ? 't-ac' : '',on:{"click":function($event){return _vm.toggle(i)}}},[_vm._v(" "+_vm._s(t.name)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }